// Hero/styles.tsx
import styled from "styled-components"
import backgroundImg from "../../../../app/assets/img/hero.jpg"

export const Layout = styled.section`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 2.5rem;

  @media (max-width: 992px) {
    padding: 1rem 1rem;
  }
`

export const HeroContainer = styled.section`
  position: relative;
  width: 100%;
  height: 90vh;
  color: white;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
`

export const HeroHeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
  display: ${({ scrolled }) => (scrolled ? "none" : "block")};
  &.fade-in {
    opacity: 1;
    transform: translateY(0);
    transition: all 0.4s ease-in-out;
  }

  &.fade-out {
    opacity: 0;
    transform: translateY(-20px);
    transition: all 0.4s ease-in-out;
    pointer-events: none;
  }
`

export const BackgroundImage = styled.div`
  background-image: url(${backgroundImg});
  background-size: cover;
  background-position: center;
  filter: brightness(0.6);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;

  @media (max-width: 992px) {
    background-position: left;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1200px;
  width: 90%;
  padding: 0 1rem;
  margin-bottom: 8vh;

  @media (max-width: 992px) {
    margin-bottom: 10vh;
    width: 95%;
  }

  @media (max-width: 576px) {
    margin-bottom: 12vh;
  }
`

export const Title = styled.h1`
  margin-bottom: 1rem;
  line-height: 1.2;

  font-size: 3.5rem;
  @media (max-width: 992px) {
    font-size: 2.8rem;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.85rem;
  }
`

export const Subtitle = styled.h3`
  font-size: 1.3rem;
  line-height: 1.4;
  font-weight: 300;
  margin-bottom: 0.8rem;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 576px) {
    font-size: 0.99rem;
  }
`

export const Description = styled.h3`
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 576px) {
    font-size: 0.9rem;
  }
`
